import { useTranslation } from 'react-i18next';
import { Flex, Heading, Text } from '@radix-ui/themes';
import { Callout, PillToggle } from '@/components/common';
import { WizardScreen } from '@/components/layout';
import { ContinueButton, OnboardingWizardHeader } from '@/components/onboarding';
import { V90_INTIMACY_OPTIONS } from '@/constants';
import { useOnboardingStore } from '@/stores/onboardingStore';
import type { OnboardingStepProps } from './types';
import { useSaveAndNext } from './useSaveAndNext';

export function IntimacyStep({ flow }: OnboardingStepProps) {
  const { t } = useTranslation('onboarding');
  const selectedIntimacy = useOnboardingStore(state => state.selectedIntimacy);
  const setSelectedIntimacy = useOnboardingStore(state => state.setSelectedIntimacy);
  const saveAndNext = useSaveAndNext(flow);

  return (
    <WizardScreen header={<OnboardingWizardHeader flow={flow} onSkip={flow.skip} />}>
      <Flex direction="column" gap="4" py="2" pb="5">
        <Heading size="5" weight="light">
          {t('steps.intimacy.title')}{' '}
          <Text size="1" color="gray" as="span">
            {t('steps.intimacy.optional')}
          </Text>
        </Heading>
        <Callout>{t('steps.intimacy.callout')}</Callout>
        <PillToggle
          type="multiple"
          options={V90_INTIMACY_OPTIONS}
          value={selectedIntimacy}
          onValueChange={setSelectedIntimacy}
        />
        <ContinueButton onClick={saveAndNext}>{t('actions.continue')}</ContinueButton>
      </Flex>
    </WizardScreen>
  );
}
